<div
  *ngIf="isUpsellVisible"
  class="sidebar-upsell"
  [ngClass]="isAdminSidebar ? 'admin-nav' : 'dashboard-nav'"
  phx-tooltip
  phxPlacement="right"
  phxTooltipOverlayClassName="sidebar-upsell-popover"
  phxTooltipMaxWidth="328"
  [phxContent]="popoverTemplate"
  [phxShowCloseIcon]="false"
  [phxTrigger]="(!isSideBarMaximized && isIconClicked) ? 'always' : 'none'"
  [phxIntent]="'positive'"
>
  <!-- Collapsed View -->
  <div
    *ngIf="!isSideBarMaximized"
    (click)="togglePopover()"
    [ngClass]="isAdminSidebar ? 'bg-white' : 'bg-black'"
    class="sidebar-upsell-icon-wrapper"
  >
    <div class="sidebar-upsell-icon">
      <i phx-icon [phxIcon]="icon"></i>
    </div>
  </div>
  <!-- Expanded View -->
  <div
    *ngIf="isSideBarMaximized"
    (click)="showUpsellModal()"
    class="sidebar-upsell-expanded"
    [ngStyle]="getDynamicStyle()"
  >
    <div class="d-flex align-items-center justify-between">
      <span class="phx-web-type-small-emphasis phx-web-color-content-on-inverted-emphasis">{{upsellConfig.header}}</span>
      <button
        (click)="dismiss()"
        phx-icon-button
        phxIconButtonSize="extra-extra-small"
        [phxIcon]="crossIcon"
        phxIconButtonType="on-bold"
      ></button>
    </div>
    <span class="phx-web-type-small phx-web-color-content-on-inverted">{{upsellConfig.body}} <i class="v-align-middle" phx-icon [phxIcon]="rightArrowIcon" color="white" [size]="12"></i></span>
</div>

<ng-template #popoverTemplate>
  <div class="d-flex flex-col justify-start px-4 py-8 gap-16">
    <div class="d-flex justify-between">
      <img width="35" [src]="upsellConfig.minimizedImage" alt="motive-card">
      <button
        (click)="dismiss()"
        phx-icon-button
        phxIconButtonSize="extra-extra-small"
        [phxIcon]="crossIcon"
      ></button>
    </div>
    <div class="d-flex flex-col pt-8">
      <span class="phx-web-type-title-small phx-web-color-content-emphasis">
        {{upsellConfig.modalConfig.heading}}
      </span>
      <span class="phx-web-type-small phx-web-color-content-subdued">
        {{upsellConfig.modalConfig.description}}
      </span>
    </div>
    <div class="d-flex gap-12">
      <button
        *ngFor="let cta of upsellConfig.modalConfig.cta"
        (click)="handleCTAClick(cta)"
        [phxButtonRole]="cta.action.is_primary ? 'primary' : 'secondary'"
        phxSize="small"
        phx-button
      >{{cta.text}}</button>
    </div>
  </div>
</ng-template>

<!-- Modal -->
<app-expansion-upsells-modal
  [isVisible]="showModal"
  (onClose)="_dismiss()"
  [heading]="upsellConfig.modalConfig.heading"
  [body]="upsellConfig.modalConfig.description"
  [CTAs]="upsellConfig.modalConfig.cta"
  [industry]="'industry'"
  [parentUpsell]="upsellType"
  [upsellId]="upsellId"
  [assetURL]="upsellConfig.modalConfig.image"
  (onComplete)="_dismiss()"
  (onDismiss)="dismissModal()"
></app-expansion-upsells-modal>